import React from 'react'
import type { RichTextInlineEntryFragment } from '../../../.graphql/generated-types'
import { ComposeComponentLink } from '../ComposeComponentLink'

export interface RichTextHyperlinkToEntryProps {
  data: RichTextInlineEntryFragment
}

export function RichTextInlineEntry({ data }: RichTextHyperlinkToEntryProps) {
  switch (data.__typename) {
    case 'ComposeComponentLink':
      return <ComposeComponentLink data={data} />
    case 'JumpLink':
      if (!data.linkIdentifier) {
        return null
      }
      return (
        <a
          className="scroll-mt-10"
          href={`#${data.linkIdentifier}`}
          id={data.linkIdentifier}
        >
          <span className="hidden">{`${data.linkIdentifier}-jump-link`}</span>
        </a>
      )
    default:
      return null
  }
}
